import { Injectable } from '@angular/core';
import { AppLinkDataService } from '../data-services/app-link-data.service';

@Injectable({ providedIn: 'root' })
export class AppLinkService {

    constructor(private appLinkDataService: AppLinkDataService) { }

    GetCheckInUrl(appointmentGuid: string): Promise<any> {
        return this.appLinkDataService.GetCheckInUrl(appointmentGuid);
    }
    AddTrackerLink(params: any): Promise<any> {
        return this.appLinkDataService.AddTrackerLink(params);
    }
    GetTrackerLink(appointmentGuid: string): Promise<any> {
        return this.appLinkDataService.GetTrackerLink(appointmentGuid);
    }
    SendTrackerSms(appointmentGuid: string): Promise<any> {
        return this.appLinkDataService.SendTrackerSms(appointmentGuid);
    }
    SendCheckInSms(id: number): Promise<any> {
        return this.appLinkDataService.SendCheckInSms(id);
    }
}